const salesNavProfile = [
  { attribute: 'class', element: 'profile-topcard-person-entity__content' }, // Contact Page - Contact content (Lusha Contacts)
  { attribute: 'id', element: 'experience-section' }, // Contacts Page - Contact Experience Organization (23/3/2022)
];

const salesNavBulk = [
  { attribute: 'class', element: 'result-lockup__name', childLocation: 0 }, // Search Page - Results container (Bulk Enrich)
  { attribute: 'class', element: 'artdeco-entity-lockup__title', childLocation: 0 }, // Search Page V2 - Results container (Bulk Enrich)
  { attribute: 'class', element: 'empty-search-results' }, // Search Page - Empty Results Container (Bulk Enrich)
  { attribute: 'class', element: 'error-message' }, // Search Page - Error Container (Bulk Enrich)
  { attribute: 'class', element: 'search-results__no-results' }, // Search Page - No Results Container (Bulk Enrich)
  { attribute: 'class', element: 'list-people-detail-header__entity' }, // Leads Page - Results Container (Bulk Enrich)
];

const salesNavCompany = [
  { attribute: 'class', element: 'link-without-visited-and-hover-state' }, // Company page
];

export const LINKEDIN_SALES_NAVIGATOR_LEGACY_INDICATORS_BY_CONTEXT_TYPE = {
  profile: salesNavProfile,
  bulk: salesNavBulk,
  company: salesNavCompany,
  unknown: [...salesNavProfile, ...salesNavBulk, ...salesNavCompany],
};
